import React from "react";
import "./App.css";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CustomModal from "./components/modal/Modal";
import Introduction from "./page/indroPage/IntroPage";
import { CONSULTATION_REGISTRATION } from "./config/appConfig";

function App() {
  // The Router wraps the header too: it shows the partner logo on the consultation link page.
  return (
    <Router>
      <div className="app-container">
        <Header />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Introduction />} />
            <Route
              path={CONSULTATION_REGISTRATION.ROUTE}
              element={
                <Introduction
                  routes={CONSULTATION_REGISTRATION.ROUTES}
                  heading={CONSULTATION_REGISTRATION.TITLE}
                />
              }
            />
          </Routes>
        </div>
        <Footer />
        <CustomModal />
      </div>
    </Router>
  );
}

export default App;
